import { render, staticRenderFns } from "./UpdateLimitHolderModal.vue?vue&type=template&id=68ef01ff&scoped=true"
import script from "./UpdateLimitHolderModal.vue?vue&type=script&lang=js"
export * from "./UpdateLimitHolderModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateLimitHolderModal.vue?vue&type=style&index=0&id=68ef01ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ef01ff",
  null
  
)

export default component.exports